import type { ModuleCode } from './modules'

export type NavigationItem = {
  label: string
  icon: string
  route: string
  roles?: string[]
  permission?: 'contabilidad' | 'amortizaciones'
  module?: ModuleCode
}

export type NavigationGroup = {
  title: string | null
  icon?: string
  roles?: string[]
  permission?: 'contabilidad' | 'amortizaciones'
  showWhenEmpty?: boolean
  module?: ModuleCode
  items: NavigationItem[]
}

export const navigationGroups: NavigationGroup[] = [
  {
    title: null,
    items: [
      { label: 'Inicio', icon: 'fa-solid fa-house', route: '/dashboard' }
    ]
  },
  {
    title: 'Clientes / Proveedores',
    icon: 'fa-solid fa-users',
    module: 'personas',
    items: [
      { label: 'Grupos', icon: 'fa-solid fa-folder-tree', route: '/grupos' },
      { label: 'Clientes', icon: 'fa-solid fa-users', route: '/clientes' },
      { label: 'Proveedores', icon: 'fa-solid fa-address-book', route: '/proveedores' }
    ]
  },
  {
    title: 'Ventas',
    icon: 'fa-solid fa-cart-shopping',
    items: [
      { label: 'Presupuestos', icon: 'fa-solid fa-file-invoice-dollar', route: '/presupuestos', module: 'ventas' },
      { label: 'Ventas', icon: 'fa-solid fa-cart-shopping', route: '/ventas', module: 'ventas' },
      { label: 'Remitos', icon: 'fa-solid fa-truck', route: '/remitos', module: 'ventas' },
      { label: 'Recibos', icon: 'fa-solid fa-file-circle-check', route: '/reporte-recibos', module: 'reportes' },
      { label: 'Cuenta corriente', icon: 'fa-solid fa-scale-balanced', route: '/cuenta-corriente/personas', module: 'personas' },
      { label: 'Listas de precios', icon: 'fa-solid fa-tags', route: '/listas-precios', module: 'productos' }
    ]
  },
  {
    title: 'Compras',
    icon: 'fa-solid fa-basket-shopping',
    module: 'compras',
    items: [
      { label: 'Compras', icon: 'fa-solid fa-basket-shopping', route: '/compras' },
      { label: 'Órdenes de pago', icon: 'fa-solid fa-money-check-dollar', route: '/ordenes-pago' }
    ]
  },
  {
    title: 'Líquido Producto',
    icon: 'fa-solid fa-file-invoice',
    module: 'liquido_producto',
    items: [
      { label: 'Líquidos Producto', icon: 'fa-solid fa-file-invoice', route: '/liquidos-producto' },
      { label: 'Lugares', icon: 'fa-solid fa-location-dot', route: '/liquidos-producto/lugares' },
      { label: 'Ítems a facturar', icon: 'fa-solid fa-list-check', route: '/liquidos-producto/facturacion-pendiente' }
    ]
  },
  {
    title: 'Productos',
    icon: 'fa-solid fa-box',
    module: 'productos',
    items: [
      { label: 'Productos', icon: 'fa-solid fa-box', route: '/productos' },
      { label: 'Categorías', icon: 'fa-solid fa-layer-group', route: '/categorias' },
      { label: 'Grupos de productos', icon: 'fa-solid fa-object-group', route: '/grupos_productos' },
      { label: 'Unidades de medida', icon: 'fa-solid fa-ruler-combined', route: '/unidades' }
    ]
  },
  {
    title: 'Movimientos',
    icon: 'fa-solid fa-right-left',
    module: 'movimientos',
    items: [
      { label: 'Tipos de movimiento', icon: 'fa-solid fa-right-left', route: '/movimientostipo' },
      { label: 'Movimientos por grupos', icon: 'fa-solid fa-people-group', route: '/movimientogrupos' }
    ]
  },
  {
    title: 'ARCA',
    icon: 'fa-solid fa-file-lines',
    items: [
      { label: 'IVA Digital', icon: 'fa-solid fa-file-lines', route: '/iva-digital', module: 'contabilidad' },
      { label: 'Puntos de venta', icon: 'fa-solid fa-store', route: '/puntos-venta', module: 'arca' },
      {
        label: 'Percepciones y retenciones',
        icon: 'fa-solid fa-scale-balanced',
        route: '/percepciones-retenciones',
        module: 'arca'
      },
      { label: 'Categoría IVA 2002', icon: 'fa-solid fa-percent', route: '/iva2002', module: 'arca' }
    ]
  },
  {
    title: 'Reportes',
    module: 'reportes',
    showWhenEmpty: true,
    items: []
  },
  {
    title: 'Configuración',
    icon: 'fa-solid fa-sliders',
    items: [
      {
        label: 'Amortizaciones',
        icon: 'fa-solid fa-chart-line',
        route: '/amortizaciones',
        permission: 'amortizaciones'
      },
      { label: 'Usuarios', icon: 'fa-solid fa-user-gear', route: '/usuarios', roles: ['admin'] },
      { label: 'Configuración', icon: 'fa-solid fa-gear', route: '/perfil', roles: ['admin'] }
    ]
  }
]
